// @flow

import { css } from 'styled-components';

export default css`
  text-decoration: none;

  &,
  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: ${props => props.theme.link.color};
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
